import Cookies from 'js-cookie'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    picArr: [],
    categPicArr: [],
    brandBigpicId: [],
    brandLogId: [],
    brandCategId: [],
    richPicId: []
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_PICID: (state, data) => {
      state.picArr = data;
    },
    // SET_CATEG_PICID: (state, data) => {
    //   state.categPicArr = data;
    // },
    SET_BIGP_PICID: (state, data) => {
      state.brandBigpicId = data;
    },
    SET_LOG_PICID: (state, data) => {
      state.brandLogId = data;
    },
    SET_CATEG_PICID: (state, data) => {
      state.brandCategId = data;
    },
    SET_RICH_PICID: (state, data) => {
      state.richPicId = data;
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    SetPicId({ commit }, data) {
      commit('SET_PICID', data);
    },
    // SetCategPicId({ commit }, data) {
    //   commit('SET_CATEG_PICID', data);
    // },
    SetBrandBigpicId({ commit }, data) {
      commit('SET_BIGP_PICID', data);
    },
    SetBrandLogId({ commit }, data) {
      commit('SET_LOG_PICID', data);
    },
    SetcategPId({ commit }, data) {
      commit('SET_CATEG_PICID', data);
    },
    SetRichPicArrId({ commit }, data) {
      commit('SET_RICH_PICID', data);
    }

  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js